import React from 'react'

import BotEditor from 'containers/BotEditor'

export const EDITOR_COMPONENTS = {
  BOT: BotEditor,
  NOT_SUPPORTED: () => <div />,
}
